import React, { useEffect } from "react";
import Footer from "./Footer";
import Header from "./header/header";

const RefundPolicy: React.FC = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
          <Header />
          <div className="">         
          <div className="container my-5">     
              <div className="card-header bg-success text-white">
                <h1 className="mb-0">
                  Refund, Cancellation, and Deferment Policy
                </h1>
              </div>
              <div className="card-body">
                <section>
                  <h2 className="mt-3">Overview</h2>
                  <p>
                    This document outlines the policies regarding refunds,
                    cancellations, and deferments for website visitors, Doyenify
                    Academy learners, and training partners enrolled in any of
                    our training programs—whether virtual or in-person.
                  </p>
                </section>
                <hr />
                <section>
                  <h2>1. Program and Training Cancellation</h2>
                  <ul>
                    <li>
                      <strong>Cancellation Notice:</strong> Cancellations must
                      be submitted in writing as a "course cancellation" request
                      at least <strong>5 working days</strong> prior to the
                      scheduled start date. Course start dates are publicly
                      available on our website.
                    </li>
                    <li>
                      <strong>Late Registrations:</strong> If registration
                      occurs less than 5 days before the start date,
                      cancellation will not be permitted once the cohort begins.
                    </li>
                    <li>
                      <strong>Course Rescheduling:</strong> Doyenify Academy
                      reserves the right to reschedule any course. In such
                      cases, notice will be provided at least{" "}
                      <strong>2 working days</strong> before the new start date.
                    </li>
                    <li>
                      <strong>Non-Refundable Cancellations:</strong> Requests
                      for cancellation after the program has commenced are
                      non-refundable, and students are required to complete the
                      training.
                    </li>
                  </ul>
                </section>
                <hr />
                <section>
                  <h2>2. Changing Courses</h2>
                  <ul>
                    <li>
                      <strong>Approval Required:</strong> Students wishing to
                      switch courses must obtain approval from the Doyenify
                      Academy Team.
                    </li>
                    <li>
                      <strong>Administrative Fee:</strong> A fee of{" "}
                      <strong>5%</strong> of the new course cost applies for
                      changes requested after the course has begun.
                    </li>
                    <li>
                      <strong>Advance Requests:</strong> For courses that have
                      not yet started, change requests must be submitted at
                      least <strong>5 days</strong> before the scheduled start
                      date.
                    </li>
                    <li>
                      <strong>Approval Timing:</strong> Course change approval
                      will be granted at least <strong>1 day</strong> prior to
                      the course commencement.
                    </li>
                    <li>
                      <strong>Payment and Refunds:</strong> Once approval is
                      issued, the new course must be paid for in full before a
                      refund is processed for the previously enrolled course.
                    </li>
                  </ul>
                </section>
                <hr />
                <section>
                  <h2>3. Refund Procedure</h2>
                  <ul>
                    <li>
                      <strong>Submission:</strong> Send a written request via
                      email detailing the reason for cancellation.
                    </li>
                    <li>
                      <strong>Documentation:</strong> Complete and return the
                      refund request form provided via email.
                    </li>
                    <li>
                      <strong>Timing:</strong> Refund requests must be submitted
                      at least <strong>5 days</strong> before the course start
                      date.
                    </li>
                    <li>
                      <strong>Processing Time:</strong>
                      <ul>
                        <li>
                          Approved cancellations: Refunds will be processed
                          within <strong>10-15 working days</strong>.
                        </li>
                        <li>
                          Erroneous payments or overpayments: Refunds will be
                          processed within <strong>5 working days</strong>.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Payment Details:</strong> Ensure that all payment
                      details are sent to <strong>info@doyenify.com</strong>.
                    </li>
                  </ul>
                </section>
                <hr />
                <section>
                  <h2>4. Program Deferment</h2>
                  <ul>
                    <li>
                      <strong>Cohort Deferment:</strong> If you are unable to
                      commence your program as scheduled, you may defer your
                      enrollment to the next available cohort. For example, if
                      enrolled in the October Product Management cohort and
                      unable to attend, you may defer to the November cohort.
                    </li>
                    <li>
                      <strong>Limitations:</strong> Deferment beyond the
                      immediate next cohort is not permitted. In such cases, no
                      refund will be issued, and the paid amount will be
                      forfeited.
                    </li>
                  </ul>
                </section>
                <hr />
                <section>
                  <h2>5. Program Access</h2>
                  <p>
                    Access to the Doyenify Academy learning platform is granted
                    for <strong>1 year</strong> following program completion.
                    However, if a refund or cancellation is requested after
                    classes have commenced, access to the learning platform will
                    be revoked immediately.
                  </p>
                </section>
                <hr />
                <section>
                  <h2>6. Contact Information</h2>
                  <p>
                    For any questions or further clarification regarding this
                    policy, please contact us at{" "}
                    <a href="mailto:info@doyenify.com">info@doyenify.com</a>.
                  </p>
                </section>
              </div>
            
          </div>
          <Footer />
          </div>
        </>
  );
};

export default RefundPolicy;
